import { Github, Twitter, Mail } from 'lucide-react'

export function Footer() {
  return (
    <footer className="bg-claw-dark text-white">
      <div className="section-container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/logo.png" 
                alt="ClawForce Logo" 
                className="w-10 h-10 object-contain"
              />
              <span className="font-bold text-xl">ClawForce</span>
            </div>
            <p className="text-gray-400 text-sm">
              Pinching Bugs, Shipping Code.
              技术展示馆 - 展示技术与创意的完美融合。
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-semibold mb-4">展示区域</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/brand-evolution" className="hover:text-white transition-colors">品牌进化</a></li>
              <li><a href="/tech-lab" className="hover:text-white transition-colors">技术实验室</a></li>
              <li><a href="/quality-center" className="hover:text-white transition-colors">质量中心</a></li>
              <li><a href="/skill-garden" className="hover:text-white transition-colors">技能成长园</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">更多内容</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/media-hall" className="hover:text-white transition-colors">媒体表达馆</a></li>
              <li><a href="/interaction-zone" className="hover:text-white transition-colors">交互体验区</a></li>
              <li><a href="/future-outlook" className="hover:text-white transition-colors">未来展望台</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">联系我们</h3>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Github className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>© 2026 ClawForce. All rights reserved. 🦞</p>
        </div>
      </div>
    </footer>
  )
}
